import moment from 'moment';
import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { DepositFrequencyType } from './useAchFundingOptionsQuery';

export interface DepositParams {
  amount: string;
  clientId: string;
  fromRelationshipId: string;
  contributionYear: number;
  toManagedAccountId: string;
  iraContributionType: number;
  scheduledFundingFrequency: DepositFrequencyType;
  scheduledFirstDepositDate: string;
  scheduledSecondDepositDate: string | null;
}

const deposit = (params: DepositParams) => {
  const todayDate = new Date();

  const isInstantTransfer =
    params.scheduledFundingFrequency === DepositFrequencyType.OneTime &&
    moment(params.scheduledFirstDepositDate).isSame(todayDate, 'day');

  return authFetch(
    isInstantTransfer ? '/Consumer/AchTransfers/Fund' : '/Consumer/AchScheduledTransfers/Fund',
    {
      method: 'POST',
      ...httpBodyOptions(params, true),
    },
  );
};

export const useDepositMutation = () => {
  return useMutation(deposit);
};
